import { inheritsLoose as _inheritsLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import { PropertySerializer } from './PropertySerializer.js';

var PropertyType = /*#__PURE__*/function (_PropertySerializer) {
  _inheritsLoose(PropertyType, _PropertySerializer);
  /**
   * Type is either form or theme. This is because we want to have independence between a
   * PropertySerializer that belongs to a Theme and a PropertySerializer that belongs to a Form
   * @type {string}
   * @readonly
   */

  function PropertyType(opts, type) {
    var _this;
    _this = _PropertySerializer.call(this, opts) || this;
    _this.type = type;
    return _this;
  }
  return PropertyType;
}(PropertySerializer);

export { PropertyType as default };
//# sourceMappingURL=PropertyType.js.map
